// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nextcloud-explorer-page {
    width: calc(100vw - 4rem);
    /* - 3rem covers the case when notification is displayed 
        since it shifts the layout down
    */
    height: calc(100vh - 10rem - 3rem);
    margin: 1rem auto 0 auto;
}

.nextcloud-explorer-page > :first-child {
    width: 10%;
    min-width: 150px;
    margin-bottom: 1rem;
}

@media screen and (max-width: 768px){
    .nextcloud-explorer-page {
        width: calc(100vw - 0.5rem);
        height: calc(100vh - 8.75rem - 3rem);
        margin-top: 0.5rem;
    }

    .nextcloud-explorer-page > :first-child {
        width: 100%;
    }    
}

@media screen and (min-width: 769px) and (max-width: 1024px){
    .nextcloud-explorer-page {
        width: calc(100vw - 2rem);
        height: calc(100vh - 8.75rem - 3rem);
        margin-top: 0.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/nextcloudExplorer.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB;;KAEC;IACD,kCAAkC;IAClC,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,2BAA2B;QAC3B,oCAAoC;QACpC,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,oCAAoC;QACpC,kBAAkB;IACtB;AACJ","sourcesContent":[".nextcloud-explorer-page {\n    width: calc(100vw - 4rem);\n    /* - 3rem covers the case when notification is displayed \n        since it shifts the layout down\n    */\n    height: calc(100vh - 10rem - 3rem);\n    margin: 1rem auto 0 auto;\n}\n\n.nextcloud-explorer-page > :first-child {\n    width: 10%;\n    min-width: 150px;\n    margin-bottom: 1rem;\n}\n\n@media screen and (max-width: 768px){\n    .nextcloud-explorer-page {\n        width: calc(100vw - 0.5rem);\n        height: calc(100vh - 8.75rem - 3rem);\n        margin-top: 0.5rem;\n    }\n\n    .nextcloud-explorer-page > :first-child {\n        width: 100%;\n    }    \n}\n\n@media screen and (min-width: 769px) and (max-width: 1024px){\n    .nextcloud-explorer-page {\n        width: calc(100vw - 2rem);\n        height: calc(100vh - 8.75rem - 3rem);\n        margin-top: 0.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
